import { FC, ReactNode } from "react";

type WrapperProps<T> = {
  Component: FC<T>;
  children: ReactNode;
} & T;

export function Wrapper<T>({ Component, children, ...rest }: WrapperProps<T>) {
  return <Component {...(rest as T)}>{children}</Component>;
}

type WrapperWhenProps<T extends object, K extends object> = {
  active: boolean;
  components: {
    active: FC<T>;
    inactive: FC<K>;
  };
  slots: {
    active: T;
    inactive: K;
    both?: T & K; // Apenas props que existem em AMBOS os componentes
  };
  children?: ReactNode;
};

Wrapper.When = function WrapperWhen<T extends Record<string, unknown>, K extends Record<string, unknown>>({ components, active, slots, children }: WrapperWhenProps<T, K>) {
  const InactiveComponent = components.inactive;
  const ActiveComponent = components.active;

  // Combina as props both com as props específicas de cada componente
  // O TypeScript vai filtrar automaticamente as props que não existem em cada componente
  const inactiveProps = { ...slots?.both, ...slots.inactive } as K & JSX.IntrinsicAttributes;
  const activeProps = { ...slots?.both, ...slots.active } as T & JSX.IntrinsicAttributes;

  if (!active) {
    return <InactiveComponent {...inactiveProps}>{children}</InactiveComponent>;
  }

  return <ActiveComponent {...activeProps}> {children}</ActiveComponent>;
};
